import React from "react";

export default function PageHeader({ title, subtitle, actions, eyebrow }) {
  return (
    <div className="flex flex-col gap-1 md:flex-row md:items-start md:justify-between mb-5 md:mb-6">
      <div className="min-w-0">
        {eyebrow && (
          <div className="text-[10px] uppercase tracking-[0.14em] font-medium text-[#0E5B52]/70 mb-1.5">
            {eyebrow}
          </div>
        )}
        <h1 className="font-display text-xl md:text-[22px] font-semibold tracking-tight text-[#0F2A26]">
          {title}
        </h1>
        {subtitle && (
          <p className="text-[13px] text-[#6B7280] mt-1 max-w-2xl leading-relaxed">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2 mt-3 md:mt-0">{actions}</div>}
    </div>
  );
}
